import {
    encodedArrayCodec,
    numberRangeCodec,
    PresetSearchParamsCustomDefaultValues,
    TableRestoreConfig,
    withModeCodec,
} from "@impero-com/ui/domain";
import * as Sentry from "@sentry/react";

export const TESTING_PROGRAM_TABLE_STATE_STORAGE_KEY = "testingProgramList";

export const TESTING_PROGRAM_LIST_COLUMN_IDS = {
    NAME: "name",
    TESTING_CONTROL_COUNT: "testingControlCount",
    ACCESS_RIGHTS: "accessRights",
} as const;

export const testingProgramListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [{ id: TESTING_PROGRAM_LIST_COLUMN_IDS.NAME, desc: false }],
    };

export const testingProgramListColumnFiltersCodecMap = {
    [TESTING_PROGRAM_LIST_COLUMN_IDS.TESTING_CONTROL_COUNT]:
        withModeCodec(numberRangeCodec),
    [TESTING_PROGRAM_LIST_COLUMN_IDS.ACCESS_RIGHTS]:
        withModeCodec(encodedArrayCodec),
};

export const testingProgramListRestoreConfig: TableRestoreConfig = {
    tableId: TESTING_PROGRAM_TABLE_STATE_STORAGE_KEY,
    defaultValues: testingProgramListTableDefaultValues,
    codecMap: testingProgramListColumnFiltersCodecMap,
    onError: Sentry.captureException,
};
